import React from "react";
import "./WhyGalaktik.css";

const WhyGalaktik = () => (
  <section className="why-galaktik" id="why">
    <h2>Neden KATAR YAPI?</h2>
    <ul>
      <li><strong>Sözleşmeye yazılı</strong>, proje bazlı net teslim takvimi </li>
      <li><strong>Tek noktadan yönetim:</strong> Keşif, statik ve anahtar teslim hattında koordinasyon; revizyon ve sahada eşzamanlı kararlar.</li>
      <li><strong>Şeffaf bütçe ve hakediş:</strong> Kalemli metraj, aşamalı ödeme ve aylık ilerleme raporu ile sürprizsiz maliyet.</li>
      <li><strong>Kalite kontrolleri:</strong> Beton-kalıp-tesisat denetimleriyle hataya yer bırakmadan ilerleme.</li>
      <li><strong>Destek:</strong> Olası eksik veya sorunlarda ekibimiz hızlıca geri dönüş yapar ve çözümü takip eder.</li>
    </ul>
  </section>
);

export default WhyGalaktik; 